import _ from 'lodash'
import Vue from 'vue'

/**
 * jsdk tools for general
 * @file: jk.js
 * @version: based on source v0.2.2 beta
 * @required: lodash
 * @author: francklin
 * @added: 2018.2.11
 * @created: 2017.2.19
 * @modified: 2017.3.27-2017.9.29,2018.2.11,2021.01.08
 * @update:
		2017.09.29 增加文件下载功能
		2020.06.19 增加对象属性映射mapObject功能
		2021.01.08 增加ID产生器
 */
const jk=(function(window,_){
	window=window||{};
	var jk=window.jk=_.extend(_,{
		/**
		 * @added: 2017.2.19
		 * @created: 2012.3.22
		 * @modified: 2012.3.22
		 */
		"is": function(obj,type){
			var toString = Object.prototype.toString,undefined;
			return (type === "Null" && obj === null) ||
				(type === "Undefined" && obj === undefined ) ||
				toString.call(obj).slice(8,-1) === type;
		},
		/**
		 * isEmpty
		 * @description: overwrite _.isEmpty of underscore
		 * @created: 2017.3.16
		 * @modified: 2017.3.16
		 */
		"isEmpty": function(){
			var isEmpty=_.isEmpty;
			return function(obj){
				if(this.is(obj,"Number")) return false;
				else if(this.is(obj,"Boolean")) return false;
				return isEmpty.call(this,obj);
			}
		}(),
		"newUnid": function(iBits){
			iBits=iBits||16;
			var aValues=[];
			for(var i=0;i<iBits;i++){
				aValues[i]=Math.floor(Math.random()*16.0).toString(16).toUpperCase();
			} 
			return aValues.join("");
		},
		"newGuid": function(){
			return [S4(),S4(),"-",S4(),"-",S4(),"-",S4(),"-",S4(),S4(),S4()].join("");   
			function S4(){   
			   return (((1+Math.random())*0x10000)|0).toString(16).substring(1);   
			}
		},	
		/**
		 * extends target object from sources
		 * @invoke:
		 *      1)$extends(source)
		 *      2)$extends(target,source)
		 *      3)$extends(isDeep,target,source)
		 *      4)$extends(isDeep,target,key,source...)
		 * @return: return target
		 * @author: francklin
		 * @created: 2017.2.18
		 * @modified: 2017.2.22
		 */
		"$extends": function(){
			var args=[].concat.apply([],arguments);
			var argLen=args.length;
			var isDeep=false,target={},parentTarget,key,sources=[],source;

			if(argLen<=3){
				for(var i=argLen-1,j=0;i>=0;i--,j++){
					switch(j){
						case 0:
							sources.push(args[i]);
							break;
						case 1:
							target=args[i];
							break;
						case 2:
							isDeep=args[i];
							break;
					}
				}
			}else{
				isDeep=args[0],target=args[1],key=args[2],sources=args.slice(3);
				if(key) {
					parentTarget=target;
					target=parentTarget[key]=parentTarget[key]||{};
				}
			}
			if(!isDeep){
				for(var i=0,source;i<sources.length;i++){
					source=sources[i];
					for(var key in source) {
						if(source.hasOwnProperty(key)) target[key] = source[key];
					}
				}
			}else{
				for(var i=0,source;i<sources.length;i++){
					source=sources[i];
					for(var key in source) {
						var copy = source[key];
						if(target === copy) continue;   // Prevent never-ending loop
						if(this.is(copy,"Object")){
							target[key] = this.$extends(target[key] || {}, copy);
						}else if(this.is(copy,"Array")){
							target[key] = this.$extends(target[key] || [], copy);
						}else{
							target[key] = copy;
						}
					}
				}
			}
			return parentTarget||target;
		},
		/**
		 * for acture project caller, extend method to 'app' sub category
		 * @invoke:
				1)apply(obj)
				2)apply(name,method)
		 * @author: francklin
		 * @created: 2017.3.16
		 * @modified: 2017.3.16
		 */
		"$apply": function(name,method){
			var args=[].concat.apply([],arguments);
			if(args.length==0){
				return;
			} else if(args.length==1){
				this.$extends(true,this,"app",args[0]);
				return this.app;
			} else if(this.is(method,"Function")){
				this.$extends(true,this,"app",{});
				return this.app[name]=method;
			}
		}
	})
	.$extends(true,_,{
		/**
		 * @added: 2017.2.18
		 */
		str: {
			"getAsciiCount" : function(str){
				return str.replace(/[^\x00-\xff]*/g,"").length;
			},
			"getNonAsciiCount" : function(str){
				return str.replace(/[\x00-\xff]*/g,"").length;
			},
			/**
			 * @modified: 2017.2.18
			 */
			"truncate" : function(str,max,padStr){
				padStr=padStr||"";
				var str1=[];
				var count=this.getAsciiCount(str)+this.getNonAsciiCount(str)*2;
				if(padStr.length>=max) return str;
				if(count<=max) return str;
				for(var i=0,j=max-padStr.length;j>0;i++,j--){
					if(str.charCodeAt(i)<=0xFF){
						str1[str1.length]=str.charAt(i);
					}else if(j>1){
						str1[str1.length]=str.charAt(i);
						j--;
					}
				}
				str=str1.join("")+padStr;
				return str;
			},
			/**
			 * @added: 2019.1.29
			 * @created: 2011.9.3
			 * @author: francklin
			 * @from: JSDK3
			 */
			"xsplit" : function(str,vOptions,vSepStr){
				var _this=str,sSepStr="";

				if(!(vSepStr instanceof Array)){
					return _this.split(vSepStr);
				}
				var values=[];
				switch(vOptions){
					case "":
					case "first":
						for(var i=0,iLen=vSepStr.length;i<iLen;i++){
							if(_this.indexOf(vSepStr[i])>=0){
								sSepStr=vSepStr[i];
								break;
							}
						}
						values=_this.split(sSepStr);
						break;
					case "any":
						var nearStrIndex, arrayIndex;
						var sTemp=_this.toString();
						while(sTemp.length){
							nearStrIndex=sTemp.length;
							arrayIndex=-1;
							for(var i=0,iStrIndex=0,iLen=vSepStr.length;i<iLen;i++){
								iStrIndex=sTemp.indexOf(vSepStr[i]);
								if(iStrIndex>=0&&iStrIndex<nearStrIndex){
									nearStrIndex=iStrIndex;
									arrayIndex=i;
								}
							}
							if(arrayIndex>=0){
								values[values.length]=sTemp.slice(0,nearStrIndex);
								sTemp=sTemp.slice(nearStrIndex+vSepStr[arrayIndex].length);
							}else{
								values[values.length]=sTemp;
								sTemp="";
							}
						}
						break;
					case "group":   //must contain an even number of elements
						if(!vSepStr.length||vSepStr.length%2!=0){
							throw "Parameter 'vSepStr' of method 'xsplit' of class 'String' must contain an even number of elements.";
						}
						var nearStrIndex,curGroupIndex;
						var sLeft="",sRight="";
						var isLeft=true;
						var sTemp=_this.toString();
						while(sTemp.length){
							nearStrIndex=sTemp.length;
							if(isLeft){
								curGroupIndex=-1;
								for(var i=0,iStrIndex=0,iLen=vSepStr.length;i<iLen;i+=2){
									iStrIndex=sTemp.indexOf(vSepStr[i]);
									if(iStrIndex>=0&&iStrIndex<nearStrIndex){
										nearStrIndex=iStrIndex;
										curGroupIndex=i;
									}
								}
								if(curGroupIndex>=0){
									sLeft=vSepStr[curGroupIndex];
									sRight=vSepStr[curGroupIndex+1];
									values.push(["",sTemp.slice(0,nearStrIndex)]);
									sTemp = sTemp.slice(nearStrIndex+sLeft.length);
								}else{
									values.push(["",sTemp]);
									break;
								}
							}else{
								nearStrIndex = sTemp.indexOf(sRight);
								if(nearStrIndex>=0){
									values.push([sLeft+sRight,sTemp.slice(0,nearStrIndex)]);
									sTemp = sTemp.slice(nearStrIndex+sRight.length);
								}else{
									throw "Missing closing delimiter \""+sRight+"\"";
								}
							}
							isLeft = !isLeft;
						}
						if(!isLeft&&sTemp==""){
							throw "Missing closing delimiter \""+sRight+"\"";
						}
						break;
					case "complex":
						break;
				}
				return values;
			}
		},
		/**
		 * @created: 2017.2.17
		 */
		num: {
			/**
			 * to fixed
			 * @invoke:
					1)toFixed(number), default output origial
					2)toFixed(number,decimals)
					3)toFixed(number,minDecimals,maxDecimals)
			 * @author: francklin
			 * @created: 2017.2.17
			 */
			"toFixed": function(number,decimals,decimals1){
				if(isNaN(number)) return "0";
				else number=Number(number);
				var minDecimals,maxDecimals,str=number.toString();
				if(isNaN(number)){
					return "0";
				} else if(!isNaN(decimals1)){
					maxDecimals=Math.min(decimals1,10);
					minDecimals=Math.min(decimals,10);
					decimals=(str.length-str.indexOf(".")-1)%str.length;
					if(decimals<minDecimals) decimals=minDecimals;
					else if(decimals>maxDecimals) decimals=maxDecimals;
				} else if(!isNaN(decimals)){
					decimals=Math.min(decimals,10);
				} else {
					return str;
				}
				return Number(number).toFixed(Math.min(decimals,10));
			},
			/**
			 * currency format
			 * @invoke:
					1)currencyFormat(number)
					2)currencyFormat(number,decimals)
					3)currencyFormat(number,minDecimals,maxDecimals)
			 * @author: francklin
			 * @created: 2017.2.17
			 * @modified: 2017.2.21
			 */
			"currencyFormat": function(number,decimals,decimals1){
				if(isNaN(number)) return "0";
				else number=Number(number);
				var minDecimals,maxDecimals,at,str=number.toString();
				if(isNaN(number)){
					return "0";
				} else if(!isNaN(decimals1)){
					maxDecimals=Math.min(decimals1,10);
					minDecimals=Math.min(decimals,10);
					decimals=(str.length-str.indexOf(".")-1)%str.length;
					if(decimals<minDecimals) decimals=minDecimals;
					else if(decimals>maxDecimals) decimals=maxDecimals;
				} else if(!isNaN(decimals)){
					decimals=Math.min(decimals,10);
				} else {
					decimals=(str.length-str.indexOf(".")-1)%str.length;
				}
				str=Number(number).toFixed(Math.min(decimals,10));
				at=(str.length-decimals-1)%str.length+1;
				return str.slice(0,at).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")+str.slice(at);
			},
			/**
			 * @author: francklin
			 * @added: 2017.2.27
			 */
			"isWithin" : function(number,min,max){
				if(typeof(min)!="number"||typeof(max)!="number"||min>max){
					throw new Error(1000,"Parameter of method 'atAround' of class 'Number' is invalid!");
				}
				if(number>=min&&number<=max) return true;
				else return false;
			},
			/**
			 * @author: francklin
			 * @added: 2017.2.27
			 */
			"isWithout" : function(number,min,max){
				if(typeof(min)!="number"||typeof(max)!="number"||min>max){
					throw new Error(1000,"Parameter of method 'atAround' of class 'Number' is invalid!");
				}
				if(number>=min&&number<=max) return false;
				else return true;
			}
		},

		/**
		 * @created: 2020.06.18
		 */
		obj: {
			/**
			 * @invoke: mapObject(obj,keys) => mapObject(obj, {from: keys, to: keys})
			 * @invoke: mapObject(obj,rule)
			 * @para obj: source object
	         * @para rule:
	                {
	                    from: required, ["key1","key2", ["key3", ["subkey1","subkey2",...] ],...]
	                    to: required, ["newkey1","newkey2",...] or ["newkey1|Number","newkey2|Date",...]
	                    mode: optional, for future, 
                            0: only get special keys from source, no contains no exist keys; 
                            1: replace special keys; 
                            2: only create speical keys of target from source, yet create if no exist keys of source
                            3: all
	                }
	         * @author: francklin
	         * @created: 2017.7.5
	         * @added: 2020.06.19
	         */
	        mapObject: function(obj,vRule){
	        	var rule;
	        	if(jk.isArray(vRule)){
	        		rule = { from: vRule, to: vRule};
	        	} else if(jk.isObject(vRule)){
	        		rule = vRule;
	        	} else {
	        		return obj;
	        	}
	            var obj1={},from=[].concat(rule.from),to=[].concat(rule.to);
	            //var callee = arguments.callee;
	            var callee = jk.obj.mapObject;
	            var convert=function(value,rule,target){
	                var paras=rule.split("|");
	                var key=paras[0];
	                var type=paras.length>1?paras[1]:(rule.defaultType||"");
	                var para=paras.length>2?paras[2]:"";
	                switch(type){
	                    case "s":
	                    case "str":
	                    case "String":
	                        if(jk.isArray(value)) value=value.join(para||",");
	                        else if(jk.isEmpty(value)) value="";
	                        else value=String(value);
	                        break;
	                    case "n":
	                    case "num":
	                    case "Number":
	                        if(jk.isEmpty(value)) value=para==="1"||para==="true"?0:"";
	                        else if(!jk.isNumber(value)) value=Number(value);
	                        break;
	                    case "b":
	                    case "bool":
	                    case "Boolean":
	                        if(jk.isEmpty(value)) value=para==="1"||para==="true"?false:"";
	                        else if(!jk.isBoolean(value)) value=Boolean(value);
	                        break;
	                    case "d":
	                    case "dt":
	                    case "Date":
	                        if(jk.isString(value)) value=new Date(value.replace(/\.|-/g,"/"));
	                        break;
	                    case "a":
	                    case "arr":
	                    case "Array":
	                        if(jk.isEmpty(value)) value=[];
	                        else if(jk.isString(value)&&para) value=value.split(para);
	                        else value=[value];
	                        break;
	                    default:
	                        //if(jk.isEmpty(value)) value="";
	                }
	                target[key]=value;
	            }
	            if(!rule.mode){
	                for(var i=0;i<from.length;i++){
	                    var have=true;

	                    if(jk.isArray(from[i])){
	                    	var fromName=from[i][0].split("|").shift();
	                    	var value=jk.reduce(fromName.split("."),function(obj,key){
		                        if(obj&&obj.hasOwnProperty(key)) return obj[key];
		                        else have=false;
		                    },obj);
		                    if(have) {
		                    	convert(value,to[i][0],obj1);
		                    	if(jk.isArray(value)){
		                    		obj1[to[i][0]]=jk.map(value,function(item){
			                    		return callee(item,{
			                    			from: from[i][1],
			                    			to: to[i][1]
			                    		});
		                    		});
		                    	} else if(jk.isObject(value)){
		                    		obj1[to[i][0]]=callee(value,{
		                    			from: from[i][1],
		                    			to: to[i][1]
		                    		})
		                    	}
		                    }
	                    } else {
	                    	var fromName=from[i].split("|").shift();
	                    	var value=jk.reduce(fromName.split("."),function(obj,key){
		                        if(obj&&obj.hasOwnProperty(key)) return obj[key];
		                        else have=false;
		                    },obj);
		                    if(have) convert(value,to[i],obj1);
	                    }
		                    
	                }
	            } else if(rule.mode==1){
	                //todo...
	            } else if(rule.mode==2){
	                for(var i=0;i<from.length;i++){
	                    var value=jk.reduce(from[i].split("."),function(obj,key){
	                        if(obj&&obj.hasOwnProperty(key)) return obj[key];
	                    },obj);
	                    convert(value,to[i],obj1);
	                }
	            } else {
	                //todo...
	            }

	            return obj1;
	        }
		}
	});

	return jk;
})(process.server?null:window,_);

export default ({app}) => {
	Vue.use(_.extend(jk,{
		install(Vue){
			Vue.jk=this;
		}
	}));
	app.jk=jk;
}
